import { Vue, Component, Prop } from 'vue-property-decorator';
import template from './oeic-fund-facts-panel.vue';
import * as mws from '../../../shared/MwsViewModels';
import GlossaryPanel from '../glossary/GlossaryPanel'

@Component({
  mixins: [template],  
  components: {
    GlossaryPanel
  },
})
export default class OeicFundFactsPanel extends Vue {
  @Prop()
  data: mws.OeicFundFactsPanel;
}
